
import { FormData } from '../components/FormSubmissionHandler';

// Mock API service - replace with actual API endpoint
export class FormService {
  private static readonly API_ENDPOINT = 'https://api.sagesaver.net/signup'; // Replace with actual endpoint
  private static readonly MOCK_MODE = true; // Set to false when real API is available

  static async submitSignup(data: FormData): Promise<void> {
    // Add timestamp for CAN-SPAM compliance
    const submissionData = {
      ...data,
      timestamp: new Date().toISOString(),
      ipAddress: await this.getClientIP(),
      userAgent: navigator.userAgent,
      source: 'website',
      canSpamCompliant: true
    };

    if (this.MOCK_MODE) {
      // Mock submission for development
      console.log('Form submission (MOCK):', submissionData);
      
      // Simulate API delay
      await new Promise(resolve => setTimeout(resolve, 1500));
      
      // Simulate occasional errors for testing
      if (Math.random() < 0.1) {
        throw new Error('Network error. Please try again.');
      }

      // Store in localStorage for development
      const existingSubmissions = JSON.parse(localStorage.getItem('sageSignups') || '[]');
      existingSubmissions.push(submissionData);
      localStorage.setItem('sageSignups', JSON.stringify(existingSubmissions));
      
      return;
    }

    // Real API submission
    try {
      const response = await fetch(this.API_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(submissionData)
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `Server error: ${response.status}`);
      }

      const result = await response.json();
      console.log('Form submitted successfully:', result);
    } catch (error) {
      console.error('Form submission error:', error);
      throw error;
    }
  }

  private static async getClientIP(): Promise<string> {
    try {
      // In production, you might want to use a service to get the real IP
      // For now, return a placeholder
      return 'unknown';
    } catch {
      return 'unknown';
    }
  }

  // Email validation service
  static validateEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  // Phone validation service
  static validatePhone(phone: string): boolean {
    if (!phone) return true; // Phone is optional
    const phoneRegex = /^[\+]?[1-9][\d]{0,15}$/;
    return phoneRegex.test(phone.replace(/[\s\-\(\)]/g, ''));
  }

  // Get stored submissions (for development/testing)
  static getStoredSubmissions(): FormData[] {
    if (this.MOCK_MODE) {
      return JSON.parse(localStorage.getItem('sageSignups') || '[]');
    }
    return [];
  }

  // Clear stored submissions (for development/testing)
  static clearStoredSubmissions(): void {
    if (this.MOCK_MODE) {
      localStorage.removeItem('sageSignups');
    }
  }
}
